<template>
  <select v-model="selectedMonth" @change="onSelectChange" class="custom-select custom-select-sm">
    <option value="0" selected>{{ selectDefault }}</option>
    <option :value="index" v-for="(month, index) in months" :key="index">{{ month }}</option>
  </select>
</template>

<script>
export default {
  props: {
    months: Object,
    selectDefault: String,
  },

  data() {
    return {
      selectedMonth: 0,
      url: '',
    }
  },

  mounted() {
    this.url =  new URL(window.location.href)

    if (this.url.search.length) {
      const query = new URLSearchParams(this.url.search)

      const queryMonth = query.get('month')

      if (queryMonth) {
        this.selectedMonth = query.get('month')
      }
    }
  },

  methods: {
    onSelectChange() {
      const params = new URLSearchParams(this.url.search)

      params.set('month', this.selectedMonth)

      this.url.search = params.toString();

      window.location.replace(this.url.toString());
    }
  }
}
</script>
